import { useContext, useEffect } from "react"
import { MainContext } from "../../controllers/main"
import { registerPageEvent } from "../../services/utils/utils"
import CommunityDesktop from "../../components/community/CommunityDesktop"
import CommunityMobile from "../../components/community/CommunityMobile"

const Community = () => {
  const { isMobile } = useContext(MainContext)

  // register google analytics event
  useEffect(() => {
    registerPageEvent("community")
  }, [])

  return isMobile ? <CommunityMobile /> : <CommunityDesktop />
}

export default Community
